export default {
  common: {
    backLink: '← Back to Search++',
    purchaseLabel: 'Buy License (Stripe)',
    trialDownload: 'Download Trial',
    contact: 'Contact: <a href="mailto:searchkun@gmail.com">searchkun@gmail.com</a>',
    copyright: 'Copyright(c) All rights reserved.'
  },
  nav: {
    items: ['Products', 'Features', 'Release Notes', 'Customer Voices', 'Purchase', 'Links', 'FAQ', 'Registration']
  },
  home: {
    title1: 'Index-Based Full-Text Search Tool',
    title2: 'Search++',
    updateDate: 'Last updated: September 28, 2026',
    evalLabel: 'Vector review: search results with a high sense of “reliability”',
    specTitle: 'Specifications and Pricing',
    detailLink: 'Details and Download →',
    shareware: 'Shareware. A free 30-day trial of all features is available.',
    memoTitle: 'Important Notes',
    memo1: 'On Windows XP, you need to install the <a href="https://www.microsoft.com/en-us/download/details.aspx?id=26368" target="_blank">Microsoft VC++ 2008 SP1 Redistributable Package</a>.',
    spec: [
      {
        id: '1',
        name: 'Search++ Std Edition',
        icon: 'el-icon-monitor',
        color: 'color:#409EFF',
        version: '6.2.1.3',
        OS: 'Windows XP, 7, Vista, Server 2003/2008, 8, 10',
        Bit: '32Bit / 64Bit',
        price: '3,410 JPY (tax incl.)',
        priceType: '',
        feature: 'Supports 32-bit and 64-bit. Limited to 1 GB of usable memory.'
      },
      {
        id: '2',
        name: 'Search++ Pro Edition',
        icon: 'el-icon-monitor',
        color: 'color:#67C23A',
        version: '6.2.1.3',
        OS: 'Windows 10, 11',
        Bit: '64Bit',
        price: '5,602 JPY (tax incl.)',
        priceType: '',
        feature: 'Optimized for 64-bit. No memory limit.'
      },
      {
        id: '3',
        name: 'Search++ Mac Edition',
        icon: 'el-icon-monitor',
        color: 'color:#E6A23C',
        OS: 'macOS',
        Bit: '64Bit',
        price: '5,602 JPY (tax incl.)',
        priceType: '',
        feature: 'Same features as the Pro Edition. Security settings approval is required before first launch.'
      },
      {
        id: '4',
        name: 'MojiScan',
        icon: 'el-icon-document',
        color: 'color:#0c86e8',
        OS: 'Windows 10, 11',
        Bit: '64Bit',
        price: '3,410 JPY (tax incl.)',
        priceType: 'primary',
        priceStyle: 'background-color:#0c86e8;border-color:#0c86e8;',
        feature: 'Japanese OCR, PDF editing, merging, splitting and more. Works with Search++.',
        linkTo: '/mojiscan'
      },
      {
        id: '5',
        name: 'BookMarkSearch',
        icon: 'el-icon-link',
        color: 'color:#7958DB',
        OS: 'Windows 10, 11',
        Bit: '64Bit',
        price: '3,410 JPY (tax incl.)',
        priceType: 'warning',
        feature: 'Full-text search across browser bookmarks and history by title, URL, folder, and page content. Search++ series.',
        linkTo: '/bookmarksearch'
      },
      {
        id: '6',
        name: 'SlackInvoice',
        icon: 'el-icon-chat-dot-round',
        color: 'color:#4A154B',
        OS: 'Slack',
        Bit: 'Web',
        price: 'Free during early access',
        priceType: 'success',
        feature: 'Create and send Stripe invoices, manage customers, and get paid alerts - all from Slack. Free to try.',
        linkTo: 'https://www.searchplusplus.jp/slackinvoice',
        external: true
      }
    ]
  },
  feature: {
    featuresTitle: 'Key Features',
    demoTitle: 'Demonstration',
    manualTitle: 'Manuals',
    manualStd: 'Std Edition',
    manualPro: 'Pro Edition',
    previewStd: 'manual.pdf (Preview)',
    previewPro: 'manual_pro.pdf (Preview)',
    popoverStd: 'Std Edition Manual',
    popoverPro: 'Pro Edition Manual',
    openInNewWindow: 'Open in new window',
    items: [
      {
        id: '1',
        icon: 'el-icon-files',
        feature: 'Supports a wide variety of file formats',
        childrenFeatures: [
          'MS PowerPoint (PPT, PPTX)',
          'MS Word (RTF, DOC, DOCX)',
          'MS Excel (XLS, XLSX)',
          'MS Outlook (MSG, EML)',
          'MS Visio (VSD)',
          'HTML, HTM',
          'Open Office Format (ODT etc.)',
          'Ichitaro',
          'Fuji Xerox Docuworks (IFILTER required)',
          'Various text files (*.txt, *.log, *.java, *.cpp, *.c, *.bat, *.config)',
          'PDF (OCR-ed recommended)'
        ]
      },
      {
        id: '2',
        icon: 'el-icon-setting',
        feature: 'Simple setup process',
        childrenFeatures: [
          'Std Edition: just unzip and run',
          'Pro Edition: run the bundled Startup.exe for initial setup'
        ]
      },
      {
        id: '3',
        icon: 'el-icon-search',
        feature: 'Fast index-based search',
        childrenFeatures: [
          'High-speed scanning of all files under selected folders',
          'Automatic index updates in resident mode',
          'Incremental updates in non-resident mode (instant update button)'
        ]
      },
      {
        id: '4',
        icon: 'el-icon-view',
        feature: 'Rich preview features',
        childrenFeatures: [
          'Show excerpts of matching sections from search results',
          'View and verify file contents directly'
        ]
      }
    ]
  },
  download: {
    titleDownload: 'Download',
    titlePurchase: 'How to Purchase',
    day30trial: 'A free 30-day trial of all features is available. Please try it before you buy.',
    products: [
      {
        name: 'Search++ Std Edition',
        desc: [
          'The Std Edition supports both 32-bit and 64-bit operating systems. No installation is required, but the maximum file size it can process is 30 MB.',
          '(Because 32-bit is supported, there is a limit on usable memory.)'
        ],
        links: [
          '<a href="https://www.searchplusplus.jp/download/6213/SearchStd6213_J.zip">Std Edition (Version 6.2.1.3) download (zip) <= Remember to extract the file after downloading</a>'
        ],
        guide: 'Std Edition quick start guide'
      },
      {
        name: 'Search++ Pro Edition',
        desc: [
          'The Pro Edition supports 64-bit operating systems only. Installation is required, but it makes full use of 64-bit performance and can handle large files.',
          '(For example, with default settings it can process 500 MB self-scanned PDFs.)'
        ],
        links: [
          '<a href="https://www.searchplusplus.jp/download/6213/SearchPro6213_J.zip">Pro Edition (Version 6.2.1.3) download (zip) <= Remember to extract the file after downloading</a>'
        ],
        guide: 'Pro Edition quick start guide'
      },
      {
        name: 'Search++ Mac Edition',
        desc: [
          'The version for macOS. Click the dmg file and copy it into the Applications folder. Then launch Searchplusplus.app from the Applications folder.'
        ],
        links: [
          '<a href="https://www.searchplusplus.jp/download/6101/SearchMac6101.dmg">Mac Edition (Version 6.1.0.1) download (dmg)</a>'
        ],
        guide: ''
      }
    ],
    purchase: [
      {
        id: '0',
        name: 'Method 1',
        subtitle: 'Contact the author directly to purchase',
        steps: [
          'Send an email to the contact address (searchkun@gmail.com) stating that you would like to purchase',
          'We will reply with the bank transfer details for the fee (Std Edition incl. tax: 3,410 JPY, Pro Edition incl. tax: 5,602 JPY, Mac Edition incl. tax: 5,602 JPY)',
          'Please transfer the payment to the designated account',
          'Once the transfer is confirmed, we will email the license information and download link to you'
        ]
      },
      {
        id: '1',
        name: 'Method 2',
        subtitle: 'Pay by credit card via PayPal',
        steps: [
          ['Click the icon below to open the PayPal purchase page (Std Edition incl. tax: 3,410 JPY, Pro Edition incl. tax: 5,602 JPY, Mac Edition incl. tax: 5,602 JPY)',
            '<div style="display:flex;">',
            '<h4 style="color:DarkBlue;font-weight:bold">Std Edition</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="KECBBA27LQ6GJ">',
            '<input type="image" src="https://www.searchplusplus.jp/stdbuy.png" border="0" name="submit" alt="PayPal - online, safer and easier payment">',
            '<img alt="" border="0" title="Std Edition" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            '<h4 style="color:ForestGreen;font-weight:bold;padding-left: 10px">Pro Edition</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="ETWN4J2CB5E9A">',
            '<input type="image" src="https://www.searchplusplus.jp/probuy.png" border="0" name="submit" alt="PayPal - online, safer and easier payment">',
            '<img alt="" border="0" title="Pro Edition" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            '<h4 style="color:Indigo;font-weight:bold;padding-left: 10px">Mac Edition</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="723FVNH3H89PN">',
            '<input type="image" src="https://www.searchplusplus.jp/macbuy.png" border="0" name="submit" alt="PayPal - online, safer and easier payment">',
            '<img alt="" border="0" title="Mac Edition" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            '</div>'
          ].join('\n'),
          'Set the quantity and click the "Update" button to update the amount',
          'Click the "PayPal Checkout" button to go to the next screen',
          'Click the "Pay with credit card" link, enter your card details and email address, and click "Pay". PayPal will notify us by email',
          'Once we receive PayPal notification, we will send the license key to the email address you registered in step 3'
        ]
      },
      {
        id: '2',
        name: 'Method 3',
        subtitle: 'Purchase through Vector (Std Edition incl. tax + registration fee: 3,410 JPY, Pro Edition incl. tax + registration fee: 5,602 JPY, Mac Edition incl. tax + registration fee: 5,602 JPY)',
        steps: [
          '<a href="https://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR296240">Buy the Std Edition</a>',
          '<a href="https://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR378160">Buy the Pro Edition</a>',
          '<a href="https://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR442842">Buy the Mac Edition</a>'
        ]
      }
    ]
  },
  link: {
    title: 'Links',
    ifilter: [
      'Since V2.8.2, Search++ has supported the Microsoft IFILTER interface.',
      'We have confirmed correct operation of the interface with the following products on Windows XP, Windows Vista, Windows 7 32-bit, Windows 7 64-bit, Windows 8, and Windows 10.',
      'Please check each vendor\'s usage terms before downloading and using IFILTER products. IFILTER products themselves are outside the scope of our support. Thank you for your understanding.'
    ],
    filterCards: [
      {
        name: '<a href="http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611" target="blank">【Vertical-writing PDF】</a>',
        desc: [
          '1) First, add one line to the config file (Config.xml) to use IFILTER for PDFs:',
          '<IFilter.pdf>1</IFilter.pdf>',
          '(If Search++ is running, stop it before changing the settings.)',
          '2) On Windows Vista, Windows 7, and Windows 8, download and install the software from the link above, then create the index. Search will then work.',
          'Please note that supporting vertical-writing PDFs may increase index creation time.'
        ]
      },
      {
        name: '<a href="http://www.justsystems.com/jp/download/ichitaro/ifilter/" target="blank">【Ichitaro】</a>',
        desc: [
          'When Ichitaro 13 is installed (trial or full version), the IFILTER is installed at the same time. Therefore, no separate Content Filter installation is needed on a PC with Ichitaro 13 installed.',
          'Although this is a 32-bit IFILTER, it can also be used on 64-bit operating systems.'
        ]
      },
      {
        name: '<a href="https://support-fb.fujifilm.com/processDriverForm.do?ctry_code=SG&lang_code=en&d_lang=en&corp_pid=DWVL&rts=null&model=DocuWorks+Viewer+Light&type_id=3&oslist=Windows+10+64bit&lang_list=en" target="blank">【DocuWorks】</a>',
        desc: [
          'With DocuWorks 8.0, installing DocuWorks 8 also installs DocuWorks Content Filter 8.',
          'Therefore, no separate Content Filter installation is needed on a PC with DocuWorks 8.0 installed.'
        ]
      }
    ],
    links: [
      { href: 'http://www.vector.co.jp/soft/winnt/util/se498053.html', label: 'Vector search software collection' },
      { href: 'http://download.seesaa.jp/contents/win/system/filer/16135/', label: 'Seesaa search software collection' },
      { href: 'http://download.goo.ne.jp/software/category/win/util/file/find/', label: 'Goo search software collection' },
      { href: 'http://ja.wikipedia.org/wiki/%E5%85%A8%E6%96%87%E6%A4%9C%E7%B4%A2#.E6.9C.89.E5.84.9F_2', label: 'Wikipedia - full-text search software' },
      { href: 'http://download.nifty.com/download/win/util/file/find/', label: 'nifty search software collection' },
      { href: 'http://pdffreesoft.net/archives/pdf_search.html', label: 'Hand-picked PDF free software' },
      { href: 'http://www.altech-ads.com/product/10008348.htm', label: 'World Soft' },
      { href: 'http://ansinsoft.com/', label: 'Anshin Software' }
    ]
  },
  register: {
    name: '*Name (required)',
    mail: '*Email address (required)',
    mail2: '*Email address (required. Please enter it again to confirm)',
    company: 'Company name',
    position: 'Job title',
    occupation: 'Occupation',
    tel: 'Phone number',
    purchaseDate: '*Purchase date (required)',
    licenseNo: '*License number (required)',
    voice: 'Requests / comments',
    channel: 'How did you first hear about this product?',
    captcha: '*Enter the characters shown in the image below (required)',
    captchaAlt: 'Failed to generate the code',
    refreshCode: 'Refresh verification code',
    submit: 'Register',
    reset: 'Reset',
    errEmail: 'Invalid email address',
    errEmailMatch: 'Email addresses do not match',
    errName: 'Name is required',
    errMailRequired: 'Please enter your email address',
    errDateRequired: 'Please enter the purchase date',
    errLicRequired: 'Please enter the license number',
    errLicInvalid: 'Invalid license number',
    errCaptcha: 'Please enter the verification code',
    errInvalid: 'Invalid input. Please correct the fields and submit again.'
  },
  query: {
    loading: 'Loading...'
  },
  faq: {
    title: 'FAQ',
    queryButton: 'Inquiry Form',
    items: [
      {
        id: '1',
        question: 'During download, a warning appeared saying the file "is not commonly downloaded and could harm your computer". What should I do?',
        answer: [
          'This warning appears because of the security features of the browser itself. The Search++ software has passed virus checks and is not harmful, so answering "Keep" allows the download to continue.',
          'On Windows 10, if you see "Windows protected your PC - Windows SmartScreen prevented an unrecognized app from starting. Running this app might put your PC at risk. More info", this is a false positive from Windows 10. Click "More info" and then "Run anyway".'
        ]
      },
      {
        id: '2',
        question: 'About the installation folder',
        answer: [
          'Do not install in C:\\Program Files or C:\\Program Files (x86). (Permission issues can prevent the software from running.)',
          'C:\\Program Files\\SearchPlusPlus (✖)',
          'C:\\SearchPlusPlus (〇)',
          'D:\\SearchPlusPlus (〇)',
          'If you see an error such as "The file could not be extracted" when unzipping, or "Could not find Java SE Environment" when starting SearchPlusPlus.exe after unzipping, the OS code page setting is probably incorrect. This can be fixed by setting the OS locale to Japanese as described in FAQ 6, or by avoiding Japanese characters in the SearchPlusPlus installation folder name (for example, install to C:\\SearchPlusPlus or D:\\SearchPlusPlus).'
        ]
      },
      {
        id: '3',
        question: 'About search keywords',
        answer: [
          'Entered search terms are analyzed (keyword parsing) before searching. If any search key exists, the file is found.',
          'If you enclose a search term in double quotes, the analysis is skipped and the whole quoted string is treated as one search unit. Files containing only part of the words will not match.',
          'Therefore, when searching for a person\'s name or a place name, enclose it in half-width double quotes as a single search unit. For example, to search for 中村一郎, enter "中村一郎" in the search box.'
        ]
      },
      {
        id: '4',
        question: 'Can I search files on the company network?',
        answer: [
          'Yes. Once the shared folder is mapped to a network drive, you can search it normally.',
          'There is also a mapping function on the index target selection screen in the Options dialog.'
        ]
      },
      {
        id: '5',
        question: 'About search keywords',
        answer: [
          'Entered search terms are analyzed (keyword parsing) before searching. If any search key exists, the file is found.'
        ]
      },
      {
        id: '6',
        question: 'Is there an automatic index update function?',
        answer: [
          'In resident mode, the target folders are monitored and index data is automatically updated for changed items.'
        ]
      },
      {
        id: '7',
        question: 'Preventing garbled text',
        answer: [
          'In the Control Panel, set "Format", "Location", and "Current system locale" to "Japanese" / "Japan" respectively.'
        ]
      },
      {
        id: '8',
        question: 'Can I exclude subfolders from the search?',
        answer: [
          'On the Options screen, you can exclude specific file types by extension. You can also exclude subfolders on the folder selection screen.'
        ]
      },
      {
        id: '9',
        question: 'Is there a hotkey?',
        answer: [
          'You can call up the main search screen with a hotkey. The hotkey can be configured on the "Options" screen.',
          'However, the Adobe Reader protected mode setting may block the hotkey.',
          'How to disable protected mode differs by Adobe Reader version.',
          'In Reader X and earlier: Edit menu > Preferences > General tab, and turn off "Enable Protected Mode at startup".',
          'In Reader XI: Edit menu > Preferences > Security (Enhanced) tab, and under "Sandbox protections", turn off "Enable Protected Mode at startup".'
        ]
      },
      {
        id: '10',
        question: 'Is there an install / uninstall function?',
        answer: [
          'The Search++ Std Edition does not change the registry; just unzip the ZIP file.',
          'For the Pro Edition, just change the Windows GDI setting, unzip the ZIP file, and run Startup.exe.',
          'To uninstall, run the bundled Delete.exe or Uninstall.exe as appropriate.'
        ]
      },
      {
        id: '11',
        question: 'Can vertical-writing PDFs be searched?',
        answer: [
          'Yes, vertical-writing PDFs can be searched.',
          'Follow the steps below.',
          '1) After checking the usage terms on the vendor site that supports vertical-writing PDFs, install the IFILTER below:',
          '<a href="http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611">http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611</a>',
          '(Confirmed to work with Search++ on Windows XP and later)',
          '2) Make sure Search++ is not running.',
          'Check that there is no Search++ icon in the tray area at the bottom right, and that Ctrl+Shift does not show the Search++ search screen. If the icon is present or Ctrl+Shift shows the search screen, Search++ is running - stop it first.',
          'To stop it, press "Other functions" on the left side of the main screen and then "Exit".',
          '3) As in the example below, add the following line to config.xml in the tool folder of the Search++ installation folder:',
          '&#60;IFilter.pdf&#62;1&#60;/IFilter.pdf&#62;',
          '4) Rebuild the index, and searching will work.'
        ]
      },
      {
        id: '12',
        question: 'I use multiple PCs. Can I share a license?',
        answer: [
          'We are sorry, but the license is per PC.',
          'License sharing is not possible.',
          'If you use multiple PCs, you need one license key for each PC.'
        ]
      },
      {
        id: '13',
        question: 'The homepage shown in the Search++ main window looks old. How can I display the latest page?',
        answer: [
          'Delete the history in the Internet Options screen of the Windows Control Panel. This clears the local cache and the latest version will be displayed.'
        ]
      },
      {
        id: '14',
        question: 'I downloaded the ZIP version, and indexing and search work fine. But after restarting the OS, Search++ cannot be restarted. What should I do?',
        answer: [
          'After downloading the ZIP version, always extract it to a folder. By default, the OS opens the downloaded ZIP file instead of extracting it. Even if Searchplusplus.exe runs directly from the ZIP, the temporary files are deleted after an OS restart and the software no longer works. For beginners, we recommend using the installer version of Search++.'
        ]
      }
    ]
  },
  voc: {
    voices: [
      {
        id: '1',
        name: 'Hiro-san',
        color: 'color:Violet',
        subTitle: ['The best full-text search software I have used!'],
        voice: [
          'The best full-text search software I have used!',
          'In my work I often need to search past statements in large numbers of documents, and I have tried many full-text search programs over the years. Each had its strengths and weaknesses, and I could not find one I was fully satisfied with - until now! This software meets every requirement I can think of. I cannot do without it anymore. On top of that, the support for users is very attentive!'
        ]
      },
      {
        id: '2',
        name: 'a-natsuki',
        color: 'color:Violet',
        subTitle: ['One of the few Windows 8 programs I know of that can full-text search retail network drives.'],
        voice: [
          'As far as I know, this is one of the few Windows 8 programs that can full-text search files on retail network drives.',
          'For some reason, Windows Search dropped "network drives created on non-Windows 8 systems" from its search scope when it went from 7 to 8, so the contents of the common Linux-based network drives could no longer be searched. Without this software, I would have had to buy Windows 7. If possible, it would be great to be able to schedule index updates by time, because creating the index takes a while.'
        ]
      },
      {
        id: '3',
        name: 'E-book Navi',
        color: 'color:Violet',
        subTitle: ['When Google Desktop disappeared, I was glad to find this software.'],
        voice: [
          'Many people OCR self-scanned PDFs and use them for searching information. It is very convenient to search for the words you are looking for, but you have to open each file to search it, which is troublesome when you do not know which file contains the information or want to search all files. Previously Google Desktop supported this, and many people were lost when it was discontinued.',
          'The tool that helps in such situations is "Search++".',
          '"Search++" is an index-based full-text search tool. When you specify a folder, it indexes the file contents (the text layer for PDFs with OCR text), so you can find and display search terms across multiple files.',
          'If you map a drive, network folders are also covered, so files stored on a LANDISK can be searched too.'
        ]
      },
      {
        id: '4',
        name: 'Hana',
        color: 'color:Blue',
        subTitle: ['When translation agencies send large volumes of materials, I use "Search++". It is very handy.'],
        voice: [
          'When translating, translation agencies sometimes send a large volume of materials.',
          'This project was a fairly large medical device with many accessories, each with its own package insert. Older versions of the device package inserts were sent as reference materials, and whenever I came across an unfamiliar term, I read the relevant section (and nearby sections) of the old inserts to find or guess the translation. With so many documents, searching was hard......',
          'Windows has a search function, but it cannot search inside PDFs. That is when I use "Search++". In the initial setup you specify the search location, and when you search by keyword, all documents containing that keyword are listed on the left side of the window, with excerpts of the matching sections on the right.',
          'The search is fast, so it is very handy. It is also useful when I think "I remember having material about this topic, but I cannot remember which document it is in".'
        ]
      },
      {
        id: '5',
        name: 'Jinzai_3',
        color: 'color:Blue',
        subTitle: ['I store lots of scanned paper information on my PC, and Search++ makes it easy to retrieve what I need.'],
        voice: [
          'There are many filename search tools, but most cannot search file contents. This software can search inside files across many formats (extensions), which is extremely useful for finding my own files and downloaded information stored on my PC.',
          'I scan paper documents and store large amounts of information on my PC. For OCR I use DocuWorks from a certain manufacturer (widely used in many companies). Since Search++ Ver. 2.8.2, DocuWorks documents (.xdw) can also be searched, making it easy to retrieve the information I need. Please give it a try.'
        ]
      },
      {
        id: '6',
        name: 'osumi-jimusyo',
        color: 'color:Blue',
        subTitle: ['It is very convenient to quickly find the file you need among large amounts of vertical- and horizontal-writing PDFs.'],
        voice: [
          'It is very convenient to quickly find the file you need among large amounts of vertical- and horizontal-writing PDFs.',
          'Searching with Acrobat took a huge amount of time each time, and checking the results was tedious, but this software lets me quickly check search results with one click or open the file. It is very easy to use and I am fully satisfied. I have tried many search programs over the years, and this is the best.',
          'The support is also very kind and attentive, which is a pleasure.'
        ]
      },
      {
        id: '7',
        name: 'Tetsu',
        color: 'color:Black',
        subTitle: ['I can search parts catalogs and manuals in an instant. I bought it after a careful one-month trial.'],
        voice: [
          'My work requires using many manufacturer parts catalogs and instruction manuals in PDF, but their filenames are usually manufacturer-specific serial numbers, so it is hard to tell later which file is which. Renaming them is also problematic because frequent revisions make it hard to know whether your copy is the latest. Adobe Reader and PDF Xchange have folder search, but specifying folders is tedious and every search takes a long time. Other search tools: grep-type tools search every time, and even database-style tools only index keywords you have searched before. This software really searches in an instant, which helps a lot. The support is solid and trustworthy, too. I purchased it after a careful one-month trial.'
        ]
      },
      {
        id: '8',
        name: 'haruka1971',
        color: 'color:Black',
        subTitle: ['As a translator, I find its content search power and keyword highlighting superior to other tools.'],
        voice: [
          'I work as a translator, and searching files by English and Japanese keywords is part of my daily work. Compared with other tools, the content search power and keyword highlighting are superior. The time needed for my work has been greatly reduced. It has really helped.'
        ]
      },
      {
        id: '9',
        name: 'ti2013',
        color: 'color:Black',
        subTitle: ['Search++ is a welcome software that has finally appeared.'],
        voice: [
          'Windows Desktop Search became useless after XP. Windows 7 search seems to divide opinions, but on my PC it was completely useless. Search++ is a welcome software that has finally appeared.'
        ]
      }
    ]
  },
  mojiscan: {
    title: 'MojiScan',
    heroBadge: 'Windows 10 & 11 - 100% Local',
    tagline: 'Searchable Japanese and English documents, fully on your PC.',
    subline: 'MojiScan handles real-world PDFs: machine-readable headers, scanned bodies, mixed languages, and files that have already been through OCR. Nothing is uploaded.',
    heroNote: 'Windows 10/11. Free trial: {trialDays} days, up to {trialPagesPerDay} pages/day ({price})',
    introTitle: 'Built for real-world documents',
    introParagraphs: [
      'Most OCR tools treat a page as either scanned or searchable. Real documents are messier: scanned bodies with machine-readable headers, pasted-in signatures, and old OCR layers nobody remembers. OCR everything, and search results come back twice.',
      'MojiScan handles that mix locally on your PC. It keeps existing text, rewrites old OCR layers instead of stacking new ones, and skips duplicate lines so each word appears once. It also covers signatures, stamps, text, shapes, rotation, page extraction, splitting, and PDF merging. MojiScan 2.1 is a Windows tool for searchable Japanese and English documents, fully offline, with a 30-day trial.'
    ],
    featuresTitle: 'What Makes MojiScan Different',
    featureCards: [
      {
        icon: 'el-icon-files',
        title: 'Built for Mixed Documents',
        desc: 'A page can arrive with machine-readable headers and a scanned body, or with a signature page pasted in as a picture. MojiScan handles that mix.'
      },
      {
        icon: 'el-icon-document-checked',
        title: 'No Duplicate Search Hits',
        desc: 'Existing text is kept. An old OCR layer is rewritten instead of stacked, and duplicate OCR lines are skipped so search returns each word exactly once.'
      },
      {
        icon: 'el-icon-connection',
        title: 'Fully Offline OCR',
        desc: 'The OCR engine and its models ship inside the app, so recognition works with the network unplugged.'
      },
      {
        icon: 'el-icon-chat-dot-round',
        title: 'Japanese and English',
        desc: 'The interface switches between Japanese and English, and the same engine reads English and Latin text alongside Japanese.'
      },
      {
        icon: 'el-icon-document-add',
        title: 'Complete PDF Workspace',
        desc: 'Place a signature or stamp image, add text and shapes, rotate, extract, split, and merge PDFs in the same workspace.'
      }
    ],
    feature: 'Fully local OCR and PDF editing for searchable Japanese and English documents. Works with Search++.',
    featureList: [
      'Built for contracts, reports, exports, scans, and other real-world documents',
      'Loads PDF, PNG, JPG, and JPEG files (file picker or drag and drop)',
      'Reads what each page carries and tells body text apart from headers and page numbers',
      'Counts a page as searchable only when its body really is',
      'Shows the OCR plan before writing, asks before re-running OCR on a document that was recognised before, and never overwrites the source file',
      'Saves OCR results as searchable PDFs; PNG, JPG, and JPEG inputs are converted to PDF first',
      'Complete PDF workspace: signature or stamp placement, text and shapes, rotate, extract, split, and merge',
      'English / Japanese UI switching',
      'Free trial for {trialDays} days (up to {trialPagesPerDay} pages/day)'
    ],
    disclaimer: '* This software is primarily an OCR tool for printed documents. Handwritten text and cursive script may have significantly lower recognition accuracy, and accurate conversion is not guaranteed.',
    screenshotTitle: 'Screenshot',
    screenshotAlt: 'MojiScan screenshot',
    screenshotPlaceholder: '(Screenshot coming soon)',
    priceTitle: 'Price',
    priceLine: '{price} (free trial for {trialDays} days)',
    price: '3,410 JPY (tax incl.)',
    downloadTitle: 'Download',
    downloadDesc: 'Windows 10/11 (64-bit) standalone version. Unzip the file and run <strong>MojiScan.exe</strong>.',
    downloadLink: 'MojiScan (Version {version}) Download ({zipName})',
    faqTitle: 'FAQ',
    faqItems: [
      {
        q: 'How is the license key delivered after payment?',
        a: 'After payment is completed, the license key is delivered by email or similar.'
      },
      {
        q: 'Where do I use the license key?',
        a: 'Enter the key in the "License" dialog of the app and authenticate online.'
      },
      {
        q: 'Can I use one license on multiple PCs?',
        a: 'One license can be used on only one PC.'
      },
      {
        q: 'How accurate is the OCR?',
        a: 'The software targets printed documents. Handwritten text and cursive script may have lower recognition accuracy, and accurate conversion is not guaranteed. Always check important documents.'
      },
      {
        q: 'Can I make a scanned PDF searchable?',
        a: 'Yes. Run OCR and then choose "Save as PDF with Text Layer". The saved copy carries an invisible text layer, so it can be searched and copied. PNG, JPG, and JPEG files are converted to PDF at the same time.'
      },
      {
        q: 'Does MojiScan work with English documents?',
        a: 'Yes. The interface switches between Japanese and English, and the same engine reads English and Latin text alongside Japanese. It works with all-English files, all-Japanese files, and documents that mix both.'
      },
      {
        q: 'What happens if my PDF already contains text?',
        a: 'That text is kept. MojiScan rewrites the invisible OCR layer instead of stacking a second one, and skips OCR lines that would duplicate text the page already has, so search returns each word only once. A dialog shows this plan before the file is written, and the original PDF is never overwritten.'
      },
      {
        q: 'Can I return the product for a refund?',
        a: 'As a downloadable product, returns and refunds are not accepted. Please try the 30-day trial (up to 50 pages/day) before purchasing.'
      }
    ],
    sellerTitle: 'Returns and Seller Information',
    sellerInfo: [
      'Seller: Search++ (Contact: searchkun@gmail.com)',
      'Payment method: Stripe (credit card)',
      'License key delivery: sent by email after payment is completed (usually within 24 hours)',
      'Returns and refunds: as a downloadable product, returns and refunds are not accepted. Please verify with the trial version (30 days) before purchasing.'
    ],
    manualTitle: 'Manual',
    manualJa: 'User Guide (Japanese)',
    manualEn: 'User Guide (English)'
  },
  bookmarksearch: {
    title: 'BookMarkSearch',
    heroBadge: '100% Local Processing',
    tagline: 'Bookmark and history search, fully local.',
    subline: 'Full-text search across bookmarks by title, URL, and page content, now including your browser history. Files are never uploaded.',
    heroNote: 'Free trial: {trialDays} days ({price})',
    featuresTitle: 'Key Features',
    featureCards: [
      {
        icon: 'el-icon-lock',
        title: '100% Local Processing',
        desc: 'Bookmark files are read only on your PC. Only the URLs you open are sent out.'
      },
      {
        icon: 'el-icon-link',
        title: 'Major Browser Support',
        desc: 'Automatically detects Chrome, Edge, and Brave bookmarks and browsing history. HTML bookmark exports can also be imported.'
      },
      {
        icon: 'el-icon-search',
        title: 'Search Page Content Too',
        desc: 'Full-text search across title, URL, folder, source, and downloaded page content.'
      },
      {
        icon: 'el-icon-time',
        title: 'Browser History Search',
        desc: 'Search your Chrome, Edge, and Brave browsing history by title and URL, right next to your bookmarks.'
      }
    ],
    feature: 'Full-text search across browser bookmarks and history by title, URL, folder, and page content. Search++ series.',
    featureList: [
      'Search bookmark title, URL, folder path, source, and downloaded page content',
      'Search Chrome / Edge / Brave browsing history by title and URL',
      'Auto-detects Chrome / Edge / Brave bookmarks and imports HTML bookmark exports',
      'Double-click a result to open the URL in your default browser',
      'Free trial for {trialDays} days (all features)'
    ],
    disclaimer: '* Searching page content requires downloading each page during index rebuild. Pages that cannot be accessed are searched by title, URL, and folder name only.',
    screenshotTitle: 'Screenshot',
    screenshotAlt: 'BookMarkSearch screenshot',
    screenshotPlaceholder: '(Screenshot coming soon)',
    priceTitle: 'Price',
    priceLine: '{price} (free trial for {trialDays} days)',
    price: '3,410 JPY (tax incl.)',
    downloadTitle: 'Download',
    downloadDesc: 'Windows 10/11 (64-bit) standalone version. Unzip the file and run <strong>BookMarkSearch-{version}.exe</strong>.',
    downloadLink: 'BookMarkSearch (Version {version}) Download ({zipName})',
    faqTitle: 'FAQ',
    faqItems: [
      {
        q: 'Which browsers are supported?',
        a: 'Chrome, Edge, and Brave bookmark files and browsing history are detected automatically. Netscape/HTML bookmark exports can also be imported.'
      },
      {
        q: 'Are my bookmarks or search contents sent anywhere?',
        a: 'No. Bookmark and history data are read only locally. Only the URLs you open from the search results are sent over the network.'
      },
      {
        q: 'What is needed to search page content?',
        a: 'Pages are downloaded and indexed during "Rebuild Index". Downloaded content is cached, so later rebuilds are faster.'
      },
      {
        q: 'Can I use one license on multiple PCs?',
        a: 'One license can be used on only one PC.'
      },
      {
        q: 'Can I return the product for a refund?',
        a: 'As a downloadable product, returns and refunds are not accepted. Please try the 30-day trial before purchasing.'
      }
    ],
    sellerTitle: 'Returns and Seller Information',
    sellerInfo: [
      'Seller: Search++ (Contact: searchkun@gmail.com)',
      'Payment method: Stripe (credit card)',
      'License key delivery: sent by email after payment is completed (usually within 24 hours)',
      'Returns and refunds: as a downloadable product, returns and refunds are not accepted. Please verify with the trial version (30 days) before purchasing.'
    ],
    manualTitle: 'Manual',
    manualJa: 'User Guide (Japanese)',
    manualEn: 'User Guide (English)'
  },
  release: {
    title: 'Release Notes',
    colTime: 'Date',
    colVer: 'Version',
    searchPlaceholder: 'Enter a search keyword',
    items: [
      {
        time: 'September 28, 2026',
        ver: 'BookMarkSearch V1.1.0',
        update: [
          'Released BookMarkSearch V1.1.0',
          'Added browser history search: search Chrome, Edge, and Brave browsing history by title and URL alongside your bookmarks'
        ]
      },
      {
        time: 'September 17, 2026',
        ver: 'MojiScan V2.1',
        update: [
          'Released MojiScan V2.1',
          'When saving a searchable PDF, text the PDF already has is kept and OCR lines that would duplicate it are skipped, so search returns each word only once',
          'The status bar now reports how much of the document is body text, so pages containing only a header or a page number are no longer counted as searchable',
          'Image files can also be saved as searchable PDFs',
          'A dialog now shows what will happen to the text a PDF already carries before the searchable copy is saved',
          'OCR asks for confirmation before re-running on a PDF that already has text, and the source PDF is never overwritten'
        ]
      },
      {
        time: 'September 12, 2026',
        ver: 'MojiScan V2.0',
        update: [
          'Released MojiScan V2.0'
        ]
      },
      {
        time: 'August 24, 2026',
        ver: 'V6.2.1.3',
        update: [
          'Improved index creation speed in the Std and Pro editions'
        ]
      },
      {
        time: 'August 21, 2026',
        ver: 'MojiScan V1.1 / BookMarkSearch V1.0.0',
        update: [
          'Released MojiScan V1.1 and BookMarkSearch V1.0.0'
        ]
      },
      {
        time: 'August 7, 2026',
        ver: 'MojiScan V1.1',
        update: [
          'Released MojiScan V1.1'
        ]
      },
      {
        time: 'July 4, 2026',
        ver: 'V6.2.1.2',
        update: [
          'Std and Pro editions now restore the window position and size from the previous session at startup',
          'Released the Japanese OCR / PDF editing tool "MojiScan" V1.0'
        ]
      },
      {
        time: 'April 17, 2026',
        ver: 'V6.2.1.1',
        update: [
          'Support for OASIS files (*.OAS)',
          'Fixed a layout conversion issue when moving from the initial screen to the search screen'
        ]
      },
      {
        time: 'February 26, 2026',
        ver: 'V6.2.1.0',
        update: [
          'Layout updates for Windows 10/11',
          'Re-implemented the white and black color themes'
        ]
      },
      {
        time: 'December 30, 2025',
        ver: 'V6.2.0.0',
        update: [
          'Adjusted the UI layout for Windows 10/11',
          'Performance improvements from upgrading modules, including Java'
        ]
      },
      {
        time: 'August 20, 2023',
        ver: 'V6.1.1.2 - Legacy UI',
        update: [
          'Reduced index creation time by upgrading the indexing module'
        ]
      },
      {
        time: 'October 12, 2022',
        ver: 'V6.1.1.1 - Web UI',
        update: [
          'Rebuilt the page number display',
          'Changed the left-side layout and moved pagination to the top',
          'Changed the left-side layout: removed the button bar and placed buttons next to files',
          'Right-clicking the right-hand text panel now shows a popup menu'
        ]
      },
      {
        time: 'July 11, 2022',
        ver: 'V6.1.1.0',
        update: [
          'Std and Pro editions can combine prefix search with keyword search, e.g. "Search* screen"',
          'Color theme setting for Pro, Web UI, and Std editions (Index menu > Options > Display Settings tab; switch between white and black)',
          'Web UI: search history is now shown in a dropdown list',
          'Web UI: filename and summary are now displayed in a single column'
        ]
      },
      {
        time: 'March 11, 2022',
        ver: 'V6.1.0.9',
        update: [
          'Prefix search is now available in both Std and Pro editions, e.g. "300*"',
          'Color theme setting for the Pro edition (Index menu > Options > Display Settings tab; white/black)',
          'Improved highlight rendering in the Pro edition'
        ]
      },
      {
        time: 'January 26, 2022',
        ver: 'V6.1.0.8',
        update: [
          'Rebuilt the Pro edition UI with modern web technology. The Pro edition now requires Windows 7 or later (64-bit OS).'
        ]
      },
      {
        time: 'April 2, 2021',
        ver: 'V6.1.0.7',
        update: [
          'Index updates can now be registered as a Windows service, so indexing runs even when no one is logged in. This feature is available only on the agent side of an in-house search system.'
        ]
      },
      {
        time: 'December 24, 2020',
        ver: 'V6.1.0.6',
        update: [
          'Rebuilt all dialogs to support display font sizes',
          'Fixed the issue where the Options screen could not be shown on Windows XP with the Std edition',
          'Fixed an issue where proximity searches for some terms did not highlight matches',
          'Released the new website'
        ]
      },
      {
        time: 'June 10, 2020',
        ver: 'V6.1.0.5',
        update: [
          'Faster index creation - optimized according to available memory',
          'Added a maximum available memory check to the memory tool for the Std edition',
          'Support for the Mac OS line feed code ("\\r")'
        ]
      },
      {
        time: 'April 26, 2020',
        ver: 'V6.1.0.4',
        update: [
          'The selected view ("Text", "Excerpt", or "Matching line") is now preserved and used when clicking a file',
          'Implemented "search again" for a word selected in the right-hand view',
          'Implemented network drive mapping',
          'Progress bars are now shown during index creation and search',
          'Bug fix: pressing the filter button on the toolbar now narrows the search scope'
        ]
      },
      {
        time: 'March 19, 2020',
        ver: 'V6.1.0.3',
        update: [
          'Implemented further narrowing of search results'
        ]
      },
      {
        time: 'December 1, 2019',
        ver: 'V6.1.0.2',
        update: [
          'Improved preview function and speed',
          'Files can be excluded by extension or by specifying the file',
          'Only index groups with the "rebuild" check mark are rebuilt (shelved index groups are excluded)',
          'Added Synonym to Config.xml: 1 enables similar-word search, 0 disables it. <Synonym>0</Synonym>'
        ]
      },
      {
        time: 'October 10, 2019',
        ver: 'V6.1.0.1',
        update: [
          'Changed the data structure to reduce index size',
          'Improved search and highlight display speed'
        ]
      },
      {
        time: 'June 3, 2019',
        ver: 'V6.1.0.0',
        update: [
          'Performance improvements for displaying large files',
          'Removed temporary files created when building the PST index',
          'Folder information is now shown with the index name on the main screen',
          'UI improvements',
          'Mac OS edition update (July 28)'
        ]
      },
      {
        time: 'January 8, 2019',
        ver: 'V6.0.0.1',
        update: [
          'New UI: new design icons and more',
          'Color management: configurable text, background, and highlight colors',
          'Java version update',
          'Preview function bug fixes',
          'Table header show / hide',
          'User dictionary support (Std and Pro editions)'
        ]
      },
      {
        time: 'November 9, 2018',
        ver: 'V6.0.0.0',
        update: [
          'Released the Mac OS edition',
          'Proximity search with compound-word support',
          'User dictionary support',
          'Bug fix for the hotkey that calls the main screen: prevented mis-triggering',
          'Bug fixes for copy / move / delete processing',
          'Adjusted the top layout of the main screen so the search box is not hidden on some operating systems'
        ]
      },
      {
        time: 'August 12, 2018',
        ver: 'V5.0.0.1',
        update: [
          'Similar-word search is now available. This feature requires an internet connection. To disable it, add the following line to Config.xml: <Synonym>70</Synonym>'
        ]
      },
      {
        time: 'July 20, 2018',
        ver: 'V5.0.0.0',
        update: [
          'Right-click menu now switches between "Text", "Excerpt", and "Matching line" views',
          'The current row is marked when switching views via the right-click menu',
          'The UI now auto-adjusts for tablets based on screen resolution',
          'Email files (MSG, EML) now show the email sent date instead of the file date, and can be filtered by it'
        ]
      },
      {
        time: 'February 16, 2018',
        ver: 'V4.0.0.10',
        update: [
          'PST file search is now possible',
          'Target and excluded file types can now be selected via dialogs on the Options screen'
        ]
      },
      {
        time: 'October 25, 2017',
        ver: 'V4.0.0.9',
        update: [
          'Implemented the file preview function',
          'Right-click in the preview window: zoom in / out, next page, previous page',
          'Fixed the memory setting tool issue'
        ]
      },
      {
        time: 'September 1, 2017',
        ver: 'V4.0.0.8',
        update: [
          'Implemented file sharing',
          'Implemented an HTTP server',
          'Added web search: with one button, search the entered keyword on Bing, Google, Wiki, or Yahoo'
        ]
      },
      {
        time: 'May 30, 2017',
        ver: 'V4.0.0.7',
        update: [
          'Double-clicking the recent files list navigates to the main screen',
          'The recent files list can be cleared',
          'Up and down arrow keys now select the search history and update the text box',
          'Search keyword history can be cleared'
        ]
      },
      {
        time: 'April 11, 2017',
        ver: 'V4.0.0.6',
        update: [
          'Filter conditions are kept until the clear button is pressed, and applied to subsequent searches',
          'Implemented the recent files list',
          'Added an option for high-resolution displays'
        ]
      },
      {
        time: 'March 16, 2017',
        ver: 'V4.0.0.5',
        update: [
          'Improved preview speed',
          'Improved filename search speed',
          'Improved index creation speed'
        ]
      },
      {
        time: 'February 17, 2017',
        ver: 'V4.0.0.3',
        update: [
          'Implemented incremental filename search',
          'Filename search results are now underlined',
          'Authentication is now automatically released when uninstalling'
        ]
      },
      {
        time: 'November 30, 2016',
        ver: 'V4.0.0.2',
        update: [
          'Rebuild a specific index',
          'If the index data is on an external HDD and the drive letter changes after unplugging, the index folder is detected and reset automatically',
          'Folder-based narrowing search',
          'Pressing the hotkey now clears the previous search results'
        ]
      },
      {
        time: 'November 9, 2016',
        ver: 'V4.0.0.1',
        update: [
          'Index shelving and restore functions',
          'Search time is shown in the status bar'
        ]
      },
      {
        time: 'October 1, 2016',
        ver: 'V4.0.0.0',
        update: [
          'Pagination for search results: page size setting and page navigation, allowing tens of thousands of result rows',
          'Dynamic height adjustment for the search result list',
          'Implemented full-text filename search',
          'Toolbar button states are now shown',
          'Added reference material: in-house search system architecture diagram https://www.searchplusplus.jp/Agent_Client.pdf'
        ]
      },
      {
        time: 'August 10, 2016',
        ver: 'V3.2.2.6',
        update: [
          'Search improvement: added an exact-match mode alongside the existing mode that searches word variants together. Exact match is the default. To switch to variant search, add <Lem>0</Lem> to Config.xml',
          'Multiple search terms can be combined with AND or OR',
          'Added add / delete / reset icons to the multiple index settings screen',
          'Checks whether the index data folder and software installation folder are writable',
          'Customized the "Notice to Users" dialog (the latest version is being submitted to Vector, and can also be downloaded from this site)'
        ]
      },
      {
        time: 'June 18, 2016',
        ver: 'V3.2.2.5',
        update: [
          'Implemented direct parsing of Ichitaro files (.jtd) without using the IFILTER, to solve the Ichitaro IFILTER font message issue'
        ]
      },
      {
        time: 'March 25, 2016',
        ver: 'V3.2.2.4',
        update: [
          'UI improvement: shows the view mode state',
          'Authentication improvement: proxy server can be configured',
          'Adjusted the progress position in the status bar during index creation',
          'Automatic backup and restore of the config file after an abnormal exit'
        ]
      },
      {
        time: 'February 15, 2016',
        ver: 'V3.2.2.3',
        update: [
          'Display adjustments for search result list icons and more',
          'Enhanced install / uninstall programs',
          'Progress (%) is shown in the status bar during index creation',
          'Single instance: starting Searchplusplus.exe twice shows the first window',
          'Bug fixes:',
          '        - Excluded folder settings',
          '        - Searching after automatic index updates'
        ]
      },
      {
        time: 'January 15, 2016',
        ver: 'V3.2.2.2',
        update: [
          'Search target folders can be set by dragging and dropping from the OS',
          'Implemented network authentication / release',
          'Implemented the notification feature'
        ]
      },
      {
        time: 'October 23, 2015',
        ver: 'V3.2.2',
        update: [
          'Made highlighting easier to understand',
          'Keywords can now be highlighted in every view',
          'English singular / plural search',
          'Japanese verb conjugation search',
          'Implemented the "previous keyword" button',
          'Bug fixes'
        ]
      },
      {
        time: 'September 26, 2015',
        ver: 'V3.2.1',
        update: [
          'Multiple index data sets can be created',
          'If memory runs low while indexing a large file, the message below appears and the file is automatically skipped after 10 seconds',
          'A "don\'t show again" option was added to the non-resident mode search message'
        ]
      },
      {
        time: 'June 21, 2015',
        ver: 'V3.1.1',
        update: [
          'Search word history is preserved',
          'Window position is preserved',
          'The main screen can be shown by shaking the mouse',
          'Created the tablet edition',
          'Created the installer edition'
        ]
      },
      {
        time: 'March 22, 2015',
        ver: 'V3.1',
        update: [
          'Index updates after a period of idle time',
          'Enhanced non-resident mode: index update function added; pressing the "Update Now" button updates the index',
          'The search list is updated automatically when the index data changes'
        ]
      },
      {
        time: 'January 12, 2015',
        ver: 'V3.0',
        update: [
          'The hotkey can be disabled',
          'When calling the screen with the hotkey, the previous search keyword is fully selected',
          'On exit, the main screen and left/right view sizes are remembered and restored next time (for example, adjust the left/right view ratio, then press "Other functions" > "Exit" to save)',
          'Files opened by external programs can be searched or not searched',
          'Automatic shutdown option for scheduled index updates, so you can index at night and shut down automatically',
          'Added a user registration button to the Options dialog'
        ]
      },
      {
        time: 'September 28, 2014',
        ver: 'V2.8.9.2',
        update: [
          'GUI update: redesigned the GUI so it displays correctly on tablets'
        ]
      },
      {
        time: 'September 7, 2014',
        ver: 'V2.8.9.1',
        update: [
          'Bug fix: index creation stopped midway when a password-protected PDF existed. Fix: if PDF parsing fails, the file is skipped and processing continues'
        ]
      },
      {
        time: 'August 29, 2014',
        ver: 'V2.8.9',
        update: [
          'GUI update: redesigned file display icons',
          'PDF page information can now be parsed. Right-clicking a PDF search result jumps to the PDF page'
        ]
      },
      {
        time: 'July 25, 2014',
        ver: 'V2.8.8',
        update: [
          'GUI update: sort, filter, and result view functions are now icons with one-click access',
          'Automatic index update settings: Options > Other tab - update at specified times / intervals, or manually'
        ]
      },
      {
        time: 'June 20, 2014',
        ver: 'V2.8.7',
        update: [
          'Text wrapping and font changes in the text display area',
          'File copy / move / delete: hold Ctrl or Shift and click files, then press the copy / move buttons on screen to choose the destination. Ctrl+A selects all files. If a file with the same name exists, you can choose whether to overwrite',
          'Fixed the multiple icons issue in the system tray',
          'Added a "Go to purchase site" button'
        ]
      },
      {
        time: 'May 3, 2014',
        ver: 'V2.8.6',
        update: [
          'Integration with Ichitaro. On PCs with Ichitaro installed, files that cannot be searched via IFILTER are opened in Ichitaro, indexed, and made searchable'
        ]
      },
      {
        time: 'April 12, 2014',
        ver: 'V2.8.5',
        update: [
          'Implemented proximity search. [Keyword A W5 Keyword B] searches for "A and B within 5 words of each other"',
          'Integration with PDF Xchange Viewer: search terms are passed and a term position list is shown',
          'Support for text in various formats, including SJIS and Unicode'
        ]
      },
      {
        time: 'February 6, 2014',
        ver: 'V2.8.4',
        update: [
          'Added detection of installed IFILTERs in the environment',
          'An animated GIF "processing" indicator is shown on the main screen during index creation and search',
          'Running the uninstall tool now detects and stops a running Search++ before deleting all files in the folder',
          'Errors from third-party IFILTERs are detected and processing continues'
        ]
      },
      {
        time: 'December 14, 2013',
        ver: 'V2.8.3',
        update: [
          'Bug fix: Japanese can now be searched in filename search',
          'XPS IFILTER support. Download and install Microsoft\'s IFILTER to search XPS files. See the Links page of this site for details',
          'Increased memory available to the IFILTER text extraction program; files of 10 MB to 40 MB (guideline) can now be handled',
          'Search result list row height is now manually configurable via Config.xml, e.g. <TableHeight>70</TableHeight> (value in pixels)'
        ]
      },
      {
        time: 'November 10, 2013',
        ver: 'V2.8.2',
        update: [
          'Search result list display order can be set on the Options screen (requires rebuilding the index)',
          'IFILTER support: download and install vendor IFILTERs to search Ichitaro, Xerox Document, vertical-writing PDFs, etc. See the Links page of this site for details'
        ]
      },
      {
        time: 'September 16, 2013',
        ver: 'V2.8',
        update: [
          'Reorganized the Options screen with tabbed groups',
          'Added an option for whether input terms are analyzed',
          'Reorganized folders; the executable is now outside the folders',
          'Bundled a private JRE so the software does not depend on an external Java environment'
        ]
      },
      {
        time: 'August 2, 2013',
        ver: 'V2.7.2',
        update: [
          'Added a "Next keyword" button that moves focus to the keyword location after showing the full text of the file',
          'Added multilingual support',
          'Text content can be selected and copied',
          'Target files can be specified on the Options screen; if unspecified, all files are processed'
        ]
      },
      {
        time: 'June 30, 2013',
        ver: 'V2.7.1',
        update: [
          'Adjusted display widths for truncated search result lists on Windows 7',
          'Keywords in matching document content are now highlighted',
          'Implemented excerpt display around the matching lines',
          'Interrupted index creation can be resumed from where it stopped. Automatic index updates are not performed for folders whose index creation is incomplete',
          'Provided a tool to set the maximum memory usage',
          'If memory runs low during indexing of large files, you can now skip the file or add memory',
          'External PDF viewers are no longer opened through Internet Explorer'
        ]
      },
      {
        time: 'May 11, 2013',
        ver: 'V2.6',
        update: [
          'Changed "sort by filename": search results are now sorted by filename instead of full path',
          'Added "show with 5 lines before and after the matching line" to the result display, i.e. an excerpt display',
          'Matching lines are highlighted in the line highlight, excerpt, and text views',
          'Threaded time-consuming operations (text display, search to matching line, excerpt display) so that even large files show progress without freezing',
          'Text panel switching: the right text panel has a context menu to switch between "show text" and "show excerpts"',
          'Bug fix: with multiple keywords and AND/OR on the "search to matching line" feature, matching lines were not always detected in versions before V2.6',
          'Log output: error logs for failed processing; failures during index creation are detected and logged',
          'Changed "search to matching line" order: versions before V2.6 sorted by similarity score; V2.6 and later sort by line number'
        ]
      },
      {
        time: 'April 6, 2013',
        ver: 'V2.5',
        update: [
          'Implemented the uninstall tool (DeleteTool.exe)',
          'Search result sorting (by update time, ascending / descending)',
          'Added text export of search results',
          'Enhanced hotkey functions',
          'Set default values for the index data location',
          'Enhanced index creation (support for large files)'
        ]
      },
      {
        time: 'February 16, 2013',
        ver: 'V2.4',
        update: [
          'Reviewed the screens',
          'Search result sorting (by filename, update time, file type) and filtering (by file type, update time)',
          'Added text export of search results',
          'AND / OR / NOT search with multiple keywords',
          'Added filename search'
        ]
      },
      {
        time: 'January 6, 2013',
        ver: 'V2.3',
        update: [
          'Enhanced "open with external program": opens the file and searches it, highlighting matches',
          'Strengthened index creation',
          'The hotkey that shows the search screen is now user-configurable',
          'Updated the documentation'
        ]
      },
      {
        time: 'December 25, 2012',
        ver: 'V2.01D',
        update: [
          'The filename being processed is shown in the message during index creation',
          'Compressed files are excluded from processing by default'
        ]
      },
      {
        time: 'December 12, 2012',
        ver: 'V2.01',
        update: [
          'Enhanced index creation: complex formulas and PDFs with images can now be parsed',
          'Ctrl+Shift shows the search screen'
        ]
      },
      {
        time: 'November 25, 2012',
        ver: 'V2.0',
        update: [
          'Implemented search target monitoring and automatic index updates',
          'Implemented tray mode',
          'Faster index creation',
          'Pressing Ctrl twice shows the search screen'
        ]
      },
      {
        time: 'October 14, 2012',
        ver: 'V1.3.2',
        update: [
          'Files can be excluded from the search scope',
          'Faster display of the multiple folder selection dialog',
          'The filename is now shown at the start of each search result row',
          'The display language can be chosen at first startup'
        ]
      },
      {
        time: 'August 25, 2012',
        ver: 'V1.3',
        update: [
          'One index can be created across multiple folders',
          'Moved the search button',
          'Right-click now shows a menu with file open, line search, and other functions',
          'Added a function to open the folder of the selected file',
          'Readjusted the message dialog when starting a search: A. create the index then search, B. search using the existing index, C. cancel - all three options available'
        ]
      },
      {
        time: 'August 12, 2012',
        ver: 'V1.2.1',
        update: [
          'Added a help button'
        ]
      },
      {
        time: 'August 2, 2012',
        ver: 'V1.2',
        update: [
          'Japanese, English, and Chinese support; added multiple index data management'
        ]
      },
      {
        time: 'July 30, 2012',
        ver: 'V1.1',
        update: [
          'Fixed a List display issue on XP'
        ]
      },
      {
        time: 'June 8, 2012',
        ver: 'V1.0',
        update: [
          'First public release'
        ]
      }
    ]
  },
  meta: {
    defaultTitle: 'Search++ - Index-Based Full-Text Search Tool',
    defaultDescription: 'A fast, lightweight index-based full-text search tool that instantly finds the information you need from large numbers of documents. Windows and Mac supported.',
    index: {
      title: 'Search++ - Index-Based Full-Text Search Tool',
      description: 'A fast, lightweight index-based full-text search tool that instantly finds the information you need from large numbers of documents. Windows and Mac supported.'
    },
    feature: {
      title: 'Features - Search++',
      description: 'Supports a wide variety of formats including MS Office, PDF, and Ichitaro. Fast index creation and rich preview functions.'
    },
    release: {
      title: 'Release Notes - Search++',
      description: 'The latest updates, new features, and bug fix history of Search++.'
    },
    voc: {
      title: 'Customer Voices - Search++',
      description: 'Evaluations and comments from users of Search++.'
    },
    download: {
      title: 'Purchase and Download - Search++',
      description: 'Purchase the Search++ Std, Pro, and Mac editions and download the latest versions.'
    },
    link: {
      title: 'Links - Search++',
      description: 'A collection of useful links related to full-text search technology and handy tools.'
    },
    contact: {
      title: 'FAQ and Contact - Search++',
      description: 'Frequently asked questions about Search++, plus contact for bugs and requests.'
    },
    register: {
      title: 'User Registration - Search++',
      description: 'Register as an authorized user of Search++.'
    },
    query: {
      title: 'Online Search (Demo) - Search++',
      description: 'A demonstration of the Search++ web interface.'
    },
    mojiscan: {
      title: 'MojiScan - Fully Local Japanese and English OCR for Windows',
      description: 'A fully local Japanese and English OCR and PDF tool for Windows that handles mixed text and scanned pages, keeps existing text, rewrites old OCR layers without duplicate search hits, and never uploads your files. MojiScan v{version} ({zipName}), {price}. Works with Search++.'
    },
    bookmarksearch: {
      title: 'BookMarkSearch - Fully Local Bookmark and History Full-Text Search Tool',
      description: 'A fully local tool for full-text searching browser bookmarks and history by title, URL, and page content. Files are never uploaded. BookMarkSearch v{version} ({zipName}), {price}. Search++ series.'
    }
  }
}
